<template>
  <div class="mail-list-wrap">
    <div class="left">
      资料清单
    </div>

    <div class="mail-list-applicants">
      <div class="mail-list-row" :class="{'m-t-20': index != 0}" v-for="(row, key, index) in expressList" :key="index" v-if="row.count">
        {{index}}
        <label class="mail-identity">
          <span>{{row.title}}</span>
        </label>
        <div class="mail-names">
          {{getApplicantNames(row.names)}}
        </div>
        <div class="mail-count-row">{{row.count}}项资料</div>
      </div>
    </div>

    <div class="right">
      <router-link class="el-button el-button--primary is-plain" :to="{name:'orderMailList', params:{oid: order.user_order_id}}">
        查看详情
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orderApplicantMailList',
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {

    /**
     * 获取资料长度
     * @param {Object} ap 申请人
     * @return {Number} 资料长度
     */
    getMaterials(ap) {
      return ap.material.material_required.filter(v => v.attr === 1).length;
    },

    getApplicantNames(names) {
      return names.join('、');
    },
  },
  computed: {

    /**
     * 邮寄资料清单
     */
    expressList() {
      if (!this.order.applicant) return [];
      const expressList = {};

      this.order.applicant.forEach((ap) => {
        expressList[ap.identity] = expressList[ap.identity] || {
          title: '',
          names: [],
          count: 0,
        };

        expressList[ap.identity].title = ap.identity;
        expressList[ap.identity].names.push(ap.applicant_name);
        expressList[ap.identity].count = this.getMaterials(ap);
      });

      return expressList;
    },
  },
};
</script>

<style lang="less" scoped>
.mail-list-wrap {
  background-color: #fff;
  display: flex;
  width: 100%;
  padding: 30px 40px 30px 40px;
  align-items: center;

  .left {
    width: 107px;
    font-size: 16px;
    color: #333;
  }

  .mail-list-applicants {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .m-t-20 {
      margin-top: 20px;
    }
    .mail-list-row {
      white-space: nowrap;
      font-size: 0;
      height: 20px;
      line-height: 20px;
      display: flex;
      align-items: center;

      .mail-count-row {
        font-size: 14px;
        color: #777;
        width: 50px;
        margin: 0 50px;
      }

      .mail-identity {
        width: 76px;
        text-align: center;
        height: 20px;
        line-height: 20px;
        border-radius: 20px;
        background-color: #aaa;
        color: white;
        transform: scale(0.9);
        font-size: 12px;
      }

      .mail-names {
        flex: 1;
        font-size: 14px;
        color: #333;
        margin-left: 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 393px;
      }
    }
  }

  .right {
    text-align: right;
    .el-button {
      width: 96px;
      height: 34px;
      line-height: 32px;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-applicant-mail-list.vue